import React from "react";
import "./style.scss";

function Card({ onClick, className, children }) {
  return (
    <div onClick={onClick} className={`card-container ${className}`}>
      {children}
    </div>
  );
}

export default Card;
